import React from 'react';
import { calculateSessionDuration, formatDateTime } from '../utils/timeCalculations';

interface SessionCardProps {
    session: {
        id: string;
        startedAt: string;
        endedAt: string | null;
        lastInteraction: string;
        createdAt: string;
        updatedAt: string;
    };
}

export const SessionCard: React.FC<SessionCardProps> = ({ session }) => {
    const isActive = !session.endedAt && (new Date(session.lastInteraction).getTime() - new Date(session.startedAt).getTime() <= 3600000);
    const duration = calculateSessionDuration(session?.startedAt, session?.lastInteraction);

    return (
        <div className="card py-0 bg-dark mb-3 border-secondary">
            <div className="card-body">
                <div className="row g-3">
                    {/* <div className="col-md-4 col-lg-2">
                        <div className="mb-2">
                            <h6 className="text-secondary mb-1">Estado</h6>
                            <span className={`badge ${isActive ? 'bg-success' : 'bg-danger'}`}>
                                {isActive ? 'Activa' : 'Finalizada'}
                            </span>
                        </div>
                    </div> */}
                    <div className="col-md-4 col-lg-2">
                        <div className="mb-2">
                            <h6 className="text-secondary mb-1">Inicio</h6>
                            <p className="mb-0">{formatDateTime(session.startedAt)}</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-3">
                        <div className="mb-2">
                            <h6 className="text-secondary mb-1">Última interacción</h6>
                            <p className="mb-0">{formatDateTime(session.lastInteraction)}</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2">
                        <div className="mb-2">
                            <h6 className="text-secondary mb-1">Duración</h6>
                            <p className="mb-0">{duration}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}; 